import { Outlet, useLocation } from 'react-router-dom';
import { useOrg } from '../org/context';
import { ProjectProvider } from '../project/ProjectContext';
import { ScanActivityIndicator } from '../scan-activity/ScanActivityIndicator';
import type { ApiClient } from '../api/client';

const PROJECT_PATH = /^\/projects\/([^/]+)/;

export interface RootLayoutProps {
  /** Injected in tests; production uses the default apiClient. */
  client?: ApiClient;
}

/**
 * Persistent app frame that never unmounts across route changes, so the
 * scan-activity indicator it hosts follows the user page to page. Purely a
 * carrier — each page still renders its own AppShell.
 */
export function RootLayout({ client }: RootLayoutProps = {}) {
  const { currentOrg } = useOrg();
  const { pathname } = useLocation();

  const segment = PROJECT_PATH.exec(pathname)?.[1];
  const projectId = segment && segment !== 'new' ? segment : null;
  const orgId = currentOrg?.id ?? null;

  return (
    <ProjectProvider {...(client ? { client } : {})}>
      <Outlet />
      {orgId && projectId ? (
        <ScanActivityIndicator orgId={orgId} projectId={projectId} {...(client ? { client } : {})} />
      ) : null}
    </ProjectProvider>
  );
}
